/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */
/** @jsx jsx */

import { css, jsx } from '@emotion/react'
import { Component } from 'react'
import { injectIntl } from 'react-intl'

import { withTransaction } from '@elastic/apm-rum-react'

import { redirectOnMount, hasRedirectOnMount, hasAnySsoMethod } from '@modules/auth/auth'

import PasswordBasedLogin from '../../../../../components/Login/PasswordBasedLogin'
import LandingPage from '../../../../../components/LandingPage'

import type { AllProps } from './types'

class BasicLogin extends Component<AllProps> {
  componentDidMount() {
    const { fetchAuthMethods, authMethods, redirectAfterLogin, redirectTo, newBearerToken } =
      this.props

    if (hasRedirectOnMount(newBearerToken)) {
      redirectOnMount({ redirectAfterLogin, redirectTo, newBearerToken })
      return
    }

    if (!authMethods) {
      fetchAuthMethods()
    }
  }

  render() {
    const { newBearerToken } = this.props

    if (hasRedirectOnMount(newBearerToken)) {
      return null // the flow almost instantly redirects away from this page
    }

    const { loginRequest } = this.props

    return (
      <LandingPage
        scrollPage={true}
        loading={loginRequest.inProgress}
        css={css({
          textAlign: 'center',
          [`@media (min-width: 768px)`]: {
            marginTop: '32vh',
            width: '18rem',
          },
        })}
      >
        {this.renderContent()}
      </LandingPage>
    )
  }

  renderContent() {
    const {
      authMethods,
      fetchAuthMethodsRequest,
      router: { location },
      loginAndRedirect,
    } = this.props
    const canSso = hasAnySsoMethod(authMethods)

    const isCheckingAuthMethods =
      authMethods == null || Boolean(fetchAuthMethodsRequest && fetchAuthMethodsRequest.inProgress)

    // This is also displayed if all auth methods are disabled - because what else are we supposed to do?
    return (
      <PasswordBasedLogin
        location={location}
        loginAndRedirect={loginAndRedirect}
        isCheckingAuthMethods={isCheckingAuthMethods}
        canSwitchMethod={canSso}
      />
    )
  }
}

export default withTransaction(`BasicLogin`, `component`)(injectIntl(BasicLogin))
